import React from 'react'
import { Link } from 'react-router-dom'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import TopMenu from '../components/top-menu'
import Footer from '../components/footer'
import './irreversible-homepage.css'

const IrreversibleHomepage = (props) => {
  return (
    <div className="irreversible-homepage-container10">
      <Helmet>
        <title>Vlad Butucariu - Senior Product Designer</title>
        <meta
          name="description"
          content="Senior product designer in Rotterdam creating clear digital products, scalable design systems, and AI-native prototypes for complex technology."
        />
        <meta
          property="og:title"
          content="Vlad Butucariu - Senior Product Designer"
        />
        <meta
          property="og:description"
          content="Product strategy, UX/UI, design systems, and AI-native prototyping for complex digital products."
        />
        <meta
          property="og:image"
          content="https://vladbutucariu.com/Images/og-home.png"
        />
        <link rel="canonical" href="https://vladbutucariu.com/" />
        <meta property="og:url" content="https://vladbutucariu.com/" />
      </Helmet>
      <div className="irreversible-homepage-thq-wrapper-elm">
        <TopMenu text3="Capabilities"></TopMenu>
        <header className="irreversible-homepage-thq-top-section-elm">
          <div className="irreversible-homepage-thq-video-div-elm">
            <video
              src="/Video/irreversible-blob-bg-1780402436590.mp4"
              loop
              muted
              autoPlay
              className="irreversible-homepage-video1"
            ></video>
            <video
              src="/Video/irreversible-blob-bg-1780402436590.mp4"
              loop
              muted
              autoPlay
              className="irreversible-homepage-video2"
            ></video>
            <video
              src="/Video/irreversible-blob-bg-1780402436590.mp4"
              loop
              muted
              autoPlay
              className="irreversible-homepage-thq-video-mobile-elm"
            ></video>
          </div>
          <div className="irreversible-homepage-thq-top-elm">
            <section className="irreversible-homepage-thq-header-elm">
              <div className="irreversible-homepage-container11">
                <h1 className="irreversible-homepage-text10">
                  <span>VLAD BUTUCARIU</span>
                  <br></br>
                </h1>
                <div
                  id="messenger"
                  className="irreversible-homepage-thq-animated-text-elm"
                ></div>
              </div>
              <div className="irreversible-homepage-thq-hero-buttons-elm">
                <h2 className="irreversible-homepage-text15">Vlad butucariu</h2>
                <h1 className="irreversible-homepage-text16">
                  Designing digital products and the systems that move them
                  forward.
                </h1>
                <h2 className="irreversible-homepage-text17">
                  <span>
                    Vlad Butucariu is a senior product designer combining
                    product strategy, UX/UI, and design systems with AI-native
                    prototyping to turn complex ideas into clear, working
                    products.
                  </span>
                  <br></br>
                </h2>
                <span className="irreversible-homepage-text20">
                  Senior Product Designer, Rotterdam
                </span>
              </div>
              <div className="irreversible-homepage-container14">
                <div className="irreversible-homepage-container15">
                  <span className="irreversible-homepage-text21">
                    Open to roles and collaborations
                  </span>
                </div>
                <div className="irreversible-homepage-container16">
                  <span className="irreversible-homepage-text22">
                    Selected work
                  </span>
                </div>
              </div>
            </section>
          </div>
          <section className="irreversible-homepage-thq-section-elm1">
            <div className="irreversible-homepage-thq-color-wrapper-elm1">
              <div className="irreversible-homepage-thq-label-elm">
                <div className="irreversible-homepage-container17">
                  <span className="irreversible-homepage-text23">Tickers</span>
                  <span className="irreversible-homepage-text24">
                    generative vector art on ledger
                  </span>
                </div>
                <div className="irreversible-homepage-container18"></div>
              </div>
              <div className="irreversible-homepage-container19">
                <div className="irreversible-homepage-container20">
                  <div className="irreversible-homepage-container21">
                    <div className="irreversible-homepage-container22">
                      <div className="irreversible-homepage-container23">
                        <Link
                          to="/work"
                          className="irreversible-homepage-navlink1"
                        >
                          <h3 className="irreversible-homepage-text25">
                            <span>Browse </span>
                            <span>projects</span>
                            <br></br>
                          </h3>
                        </Link>
                      </div>
                      <Link
                        to="/work"
                        className="irreversible-homepage-navlink2"
                      >
                        <div className="irreversible-homepage-container24">
                          <div className="irreversible-homepage-container25">
                            <div className="irreversible-homepage-container26"></div>
                            <div className="irreversible-homepage-container27"></div>
                          </div>
                          <div className="irreversible-homepage-container28">
                            <div className="irreversible-homepage-container29"></div>
                            <div className="irreversible-homepage-container30"></div>
                          </div>
                        </div>
                      </Link>
                      <Link
                        to="/work"
                        className="irreversible-homepage-navlink3"
                      >
                        <div className="irreversible-homepage-container31">
                          <div className="irreversible-homepage-container32">
                            <div className="irreversible-homepage-container33">
                              <React.Fragment>
                                <React.Fragment>
                                  {/* Responsive 3x2 Grid with Smooth Animated First Cells and Image Preloading */}
                                  <div
                                    id="animated-grid"
                                    style={{
                                      width: '100%',
                                      gap: '0px',
                                      display: 'flex',
                                      flexWrap: 'wrap',
                                    }}
                                  />

                                  <style
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        '\n  #animated-grid .row {\n    display: flex;\n    width: 100%;\n    gap: 0px;\n    margin-bottom: 0px;\n  }\n\n  #animated-grid .row:last-child {\n    margin-bottom: 0;\n  }\n\n  #animated-grid .cell {\n    height: 20px;\n    background-color: black;\n    /* fallback before image loads */\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    border-radius: 0px;\n    transition: flex-basis 0.8s ease;\n    flex-grow: 0;\n    flex-shrink: 0;\n  }\n\n  #animated-grid .row .cell:last-child {\n    flex-grow: 1;\n  }\n\n  #animated-grid .row .cell:first-child:hover {\n    flex-basis: 70%;\n  }\n\n  @media (max-width: 767px) {\n    #animated-grid .cell {\n      height: 20px;\n    }\n  }\n\n  @media (max-width: 360px) {\n    #animated-grid .cell {\n      height: 20px;\n    }\n  }\n',
                                    }}
                                  />

                                  <Script>{`
  (function () {
  function initAnimatedGrid() {
    const grid = document.getElementById('animated-grid');
    if (!grid || grid.children.length > 0) return; // prevent duplicate init

    const images = [
      '/Images/home-grid-1.png',
      '/Images/home-grid-2.png',
      '/Images/home-grid-3.svg',
      '/Images/home-grid-4.png',
      '/Images/home-grid-5.png',
      '/Images/home-grid-6.png'
    ];

    function preloadImage(url, callback) {
      const img = new Image();
      img.onload = () => callback(url);
      img.src = url;
    }

    let imgIndex = 0;
    for (let r = 0; r < 3; r++) { // ⬅ changed to 3 rows
      const row = document.createElement('div');
      row.className = 'row';

      for (let c = 0; c < 2; c++) {
        const cell = document.createElement('div');
        cell.className = 'cell';

        if (c === 0) {
          const initialWidth = Math.random() * 40 + 30;
          cell.style.flexBasis = \`\${initialWidth}%\`;
        }

        const imageUrl = images[imgIndex % images.length];
        preloadImage(imageUrl, (url) => {
          cell.style.backgroundImage = \`url(\${url})\`;
        });
        imgIndex++;

        row.appendChild(cell);
      }

      grid.appendChild(row);
    }

    function animateFirstCells() {
      const rows = grid.querySelectorAll('.row');
      rows.forEach(row => {
        const firstCell = row.querySelector('.cell:first-child');
        if (!firstCell.matches(':hover')) {
          const newWidth = Math.random() * 40 + 30;
          firstCell.style.flexBasis = \`\${newWidth}%\`;
        }
      });
    }

    setInterval(animateFirstCells, 1500);
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initAnimatedGrid();
  } else {
    document.addEventListener('DOMContentLoaded', initAnimatedGrid);
  }

  const observer = new MutationObserver(() => {
    if (document.getElementById('animated-grid') && !document.getElementById('animated-grid').children.length) {
      initAnimatedGrid();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
  })();
`}</Script>
                                </React.Fragment>
                              </React.Fragment>
                            </div>
                          </div>
                          <div className="irreversible-homepage-container34">
                            <div className="irreversible-homepage-container35">
                              <React.Fragment>
                                <React.Fragment>
                                  {/* Responsive 2x2 Grid with Smooth Animated First Cells and Image Preloading */}
                                  <div
                                    id="animated-grid"
                                    style={{
                                      width: '100%',
                                      gap: '0px',
                                      display: 'flex',
                                      flexWrap: 'wrap',
                                    }}
                                  />

                                  <style
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        '\n  #animated-grid .row {\n    display: flex;\n    width: 100%;\n    gap: 0px;\n    margin-bottom: 0px;\n  }\n\n  #animated-grid .row:last-child {\n    margin-bottom: 0;\n  }\n\n  #animated-grid .cell {\n    height: 80px;\n    background-color: none;\n    /* fallback before image loads */\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    border-radius: 0px;\n    transition: flex-basis 0.8s ease;\n    flex-grow: 0;\n    flex-shrink: 0;\n  }\n\n  #animated-grid .row .cell:last-child {\n    flex-grow: 1;\n  }\n\n  #animated-grid .row .cell:first-child:hover {\n    flex-basis: 70%;\n  }\n\n  @media (max-width: 767px) {\n    #animated-grid .row {\n    gap: 0px;\n    }\n    #animated-grid .cell {\n      height: 30px;\n    }\n  }\n\n  @media (max-width: 360px) {\n    #animated-grid .cell {\n      height: 30px;\n    }\n  }\n',
                                    }}
                                  />

                                  <Script>{`
  (function () {
  function initAnimatedGrid() {
    const grid = document.getElementById('animated-grid');
    if (!grid || grid.children.length > 0) return; // prevent duplicate init

    const images = [
      '/Images/home-grid-1.png',
      '/Images/home-grid-2.png',
      '/Images/home-grid-3.svg',
      '/Images/home-grid-4.png'
    ];

    function preloadImage(url, callback) {
      const img = new Image();
      img.onload = () => callback(url);
      img.src = url;
    }

    let imgIndex = 0;
    for (let r = 0; r < 2; r++) {
      const row = document.createElement('div');
      row.className = 'row';

      for (let c = 0; c < 2; c++) {
        const cell = document.createElement('div');
        cell.className = 'cell';

        if (c === 0) {
          const initialWidth = Math.random() * 40 + 30;
          cell.style.flexBasis = \`\${initialWidth}%\`;
        }

        const imageUrl = images[imgIndex % images.length];
        preloadImage(imageUrl, (url) => {
          cell.style.backgroundImage = \`url(\${url})\`;
        });
        imgIndex++;

        row.appendChild(cell);
      }

      grid.appendChild(row);
    }

    function animateFirstCells() {
      const rows = grid.querySelectorAll('.row');
      rows.forEach(row => {
        const firstCell = row.querySelector('.cell:first-child');
        if (!firstCell.matches(':hover')) {
          const newWidth = Math.random() * 40 + 30;
          firstCell.style.flexBasis = \`\${newWidth}%\`;
        }
      });
    }

    setInterval(animateFirstCells, 1500);
  }

  // Try init immediately if already loaded
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initAnimatedGrid();
  } else {
    document.addEventListener('DOMContentLoaded', initAnimatedGrid);
  }

  // Fallback: watch DOM in case of TeleportHQ SPA navigation
  const secondaryGridObserver = new MutationObserver(() => {
    if (document.getElementById('animated-grid') && !document.getElementById('animated-grid').children.length) {
      initAnimatedGrid();
    }
  });
  secondaryGridObserver.observe(document.body, { childList: true, subtree: true });
  })();
`}</Script>
                                </React.Fragment>
                              </React.Fragment>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="irreversible-homepage-thq-section-elm2">
            <div className="irreversible-homepage-thq-color-wrapper-elm2">
              <div className="irreversible-homepage-container36">
                <div className="irreversible-homepage-container37">
                  <img
                    alt=""
                    src="/Images/tickerpurple.200.svg"
                    className="irreversible-homepage-image1"
                  />
                  <div className="irreversible-homepage-container38">
                    <div className="irreversible-homepage-container39">
                      <span className="irreversible-homepage-text29">
                        <span>
                          I design clear, useful products for complex
                          technology. My work combines product thinking,
                          interaction design, visual systems, and close
                          collaboration with engineering.
                        </span>
                        <br></br>
                        <br></br>
                        <span>
                          Using AI-native workflows with tools such as Claude
                          Code and Codex, I move quickly from high-fidelity
                          design to functional prototypes and production-ready
                          systems without losing craft or intent.
                        </span>
                        <br></br>
                        <span>
                          <span
                            dangerouslySetInnerHTML={{
                              __html: ' ',
                            }}
                          />
                        </span>
                      </span>
                    </div>
                    <div className="irreversible-homepage-container40">
                      <h2 className="irreversible-homepage-text36">
                        Product Design
                      </h2>
                      <h2 className="irreversible-homepage-text37">
                        UX and UI Design
                      </h2>
                      <h2 className="irreversible-homepage-text38">
                        Design Systems
                      </h2>
                      <h2 className="irreversible-homepage-text39">
                        AI-native Prototyping
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="irreversible-homepage-thq-color-wrapper-elm3">
              <div className="irreversible-homepage-container41">
                <div className="irreversible-homepage-container42">
                  <img
                    alt=""
                    src="/Images/tickerpurple.200.svg"
                    className="irreversible-homepage-image2"
                  />
                  <div className="irreversible-homepage-container43">
                    <div className="irreversible-homepage-container44">
                      <span className="irreversible-homepage-text40">
                        Looking for a senior designer who can connect product
                        thinking, visual craft, and implementation? I&apos;m open
                        to product design roles and selected collaborations.
                      </span>
                    </div>
                    <div className="irreversible-homepage-container45">
                      <Link
                        to="/contact"
                        className="irreversible-homepage-navlink4"
                      >
                        <h2 className="irreversible-homepage-text41">
                          Get in Touch
                        </h2>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="irreversible-homepage-container46">
                <div className="irreversible-homepage-container47">
                  <img
                    alt=""
                    src="/Images/slash.svg"
                    className="irreversible-homepage-image3"
                  />
                </div>
              </div>
            </div>
          </section>
          <div className="irreversible-homepage-thq-stripe-elm"></div>
        </header>
        <Footer rootClassName="footerroot-class-name"></Footer>
        <div className="irreversible-homepage-thq-scripts-elm">
          <div>
            <div className="irreversible-homepage-container49">
              <React.Fragment>
                <Script>{`
    var Messenger = function(el){
      'use strict';
      var m = this;

      m.init = function(){
        m.codeletters = "ABCDEFGHIJKLMNOPRTSUVXYZ";
        m.message = 0;
        m.current_length = 0;
        m.fadeBuffer = false;
        m.messages = [
          'VLAD BUTUCARIU',
          'PRODUCT DESIGN',
          'UX/UI SYSTEMS',
          'AI PROTOTYPES',
          'COMPLEX PRODUCTS',
          'GOOD DESIGN'

        ];

        setTimeout(m.animateIn, 300);
      };

      m.generateRandomString = function(length){
        var random_text = '';
        while(random_text.length < length){
          random_text += m.codeletters.charAt(Math.floor(Math.random()*m.codeletters.length));
        } 

        return random_text;
      };

      m.animateIn = function(){
        if(m.current_length < m.messages[m.message].length){
          m.current_length = m.current_length + 2;
          if(m.current_length > m.messages[m.message].length) {
            m.current_length = m.messages[m.message].length;
          }

          var message = m.generateRandomString(m.current_length);
          \$(el).html(message);

          setTimeout(m.animateIn, 60);
        } else { 
          setTimeout(m.animateFadeBuffer, 60);
        }
      };

      m.animateFadeBuffer = function(){
        if(m.fadeBuffer === false){
          m.fadeBuffer = [];
          for(var i = 0; i < m.messages[m.message].length; i++){
            m.fadeBuffer.push({c: (Math.floor(Math.random()*12))+1, l: m.messages[m.message].charAt(i)});
          }
        }

        var do_cycles = false;
        var message = ''; 

        for(var i = 0; i < m.fadeBuffer.length; i++){
          var fader = m.fadeBuffer[i];
          if(fader.c > 0){
            do_cycles = true;
            fader.c--;
            message += m.codeletters.charAt(Math.floor(Math.random()*m.codeletters.length));
          } else {
            message += fader.l;
          }
        }

        \$(el).html(message);

        if(do_cycles === true){
          setTimeout(m.animateFadeBuffer, 150);
        } else {
          setTimeout(m.cycleText, 6000);
        }
      };

      m.cycleText = function(){
        m.message = m.message + 1;
        if(m.message >= m.messages.length){
          m.message = 0;
        }

        m.current_length = 0;
        m.fadeBuffer = false;
        \$(el).html('');

        setTimeout(m.animateIn, 100);
      };

      m.init();
    }

    
    var messenger = new Messenger(\$('#messenger'));
  `}</Script>
              </React.Fragment>
            </div>
          </div>
          <div>
            <div className="irreversible-homepage-container51">
              <React.Fragment>
                <style
                  dangerouslySetInnerHTML={{
                    __html:
                      '\n#box {\n  flex: 1;\n  animation: growShrink 4s infinite alternate ease-in-out;\n}\n\n@keyframes growShrink {\n  0%   { flex: 1; }\n  50%  { flex: 3; } /* grows */\n  100% { flex: 1; } /* shrinks */\n}\n\n',
                  }}
                />
              </React.Fragment>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default IrreversibleHomepage
